import { FiSave } from 'react-icons/fi';
import styles from './OpeningBalance.module.css';
import { formatMoney } from './openingBalanceUtils';

export default function CategoryBalancesTab({
  categories,
  categoryLines,
  total,
  readOnly,
  frozen,
  saving,
  onSave,
  onFieldChange,
}) {
  return (
    <div className="card">
      <div className="card-header">
        <h3>Category Fund Balances</h3>
        {!frozen && !readOnly && (
          <button className="btn btn-primary btn-sm" onClick={onSave} disabled={saving}>
            <FiSave /> {saving ? 'Saving...' : 'Save Categories'}
          </button>
        )}
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Category</th>
              <th>Fund Balance (Rs)</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((category) => {
              const line = categoryLines[category.id] || {};
              return (
                <tr key={category.id} className={styles.obRow}>
                  <td><strong>{category.name}</strong></td>
                  <td>
                    {readOnly ? (
                      <span className={styles.amtRight}>Rs {formatMoney(line.fundBalanceInr || 0)}</span>
                    ) : (
                      <input
                        className={styles.obInput}
                        type="number"
                        min="0"
                        step="0.01"
                        value={line.fundBalanceInr ?? ''}
                        onChange={(event) => onFieldChange(category.id, event.target.value)}
                        disabled={frozen}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td><strong>Total</strong></td>
              <td className={styles.amtRight}><strong>Rs {formatMoney(total)}</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
